import { HubFeature } from '@ats/api/cm';
import { LocDefs, LocPortal, MapLocKeys } from '@cm/core/localization';

export type CPBenefitInfoLocs = 'CPBenefitInfoButtonMoreInfo';
export const cpBenefitInfoLocs: LocDefs<CPBenefitInfoLocs> = {
	CPBenefitInfoButtonMoreInfo: {
		defaultValue: 'More Information',
		description: 'Button to go back',
		displayPath: `Benefits|Program|Button|More Information`,
		displayType: 'Button',
		feature: HubFeature.Benefit,
		legacyName: 'Benefit/Benefits.Program.Button.MoreInfo',
		portal: 'CP' as LocPortal,
	},
};

export const LOC_KEYS = MapLocKeys<CPBenefitInfoLocs>(cpBenefitInfoLocs);
